/**
 * Class2Statement (mission 10 WP15 T088; FR-017 43/6, FR-018 44/14; D.2, D.5, T.4; Legal Q15; FR-022, C-013).
 *
 * Register 37 `class2Statement`, with `years` from the window read's `terms.class2_years`, never a literal.
 * One component, so sheet 43's Class 2 card and sheet 44's statement say the same sentence (44/14: "same
 * wording as sheet 43 Class 2 card"). The screen places it; this renders the paragraph only.
 */
import { cn } from '@/components/ui/cn'
import { PROVISIONAL_COPY } from '@/lib/provisional-copy'

export interface Class2StatementProps {
  /** `terms.class2_years` (Q15, provisional). */
  years: number
  className?: string
}

export function Class2Statement({ years, className }: Class2StatementProps) {
  return (
    <p data-class2-statement className={cn('text-body-sm text-navy-700', className)}>
      {PROVISIONAL_COPY.class2Statement.render({ years })}
    </p>
  )
}
